import styled from "styled-components";
import { useState, useEffect, useContext } from "react";
import { TreeSelect } from "primereact/treeselect";
import { OrgTreeContext } from "../../../Contexts/OrgTreeContext";
import { UsersDatabaseContext } from "../../../Contexts/UserDatabaseContext";
import { CurrentUserContext } from "../../../Contexts/CurrentUserContext";
import {
  findNodeByKey,
  createAdminOrgTree,
  findNodeById,
  createNodesHighestAccessAndPersonalNode,
} from "../../../Helpers/OrgTreeFunctions";

const DashboardSelectWrapper = styled.div`
  display: flex;
  justify-content: space-around;

  .p-treeselect-panel {
    transform: translateX(-50%);
  }
`;

export default function OrgTreeSelect({
  includeUsers = false,
  teamSelect,
  selectedTeam,
  placeholder,
}: Props) {
  const [personalisedOrgTree, setPersonalisedOrgTree] = useState<
    OrgTreeItem[] | undefined
  >();
  const [selectedNodeKey, setSelectedNodeKey] = useState<string>();
  const userDatabase = useContext(UsersDatabaseContext);
  const orgTreeDatabase = useContext(OrgTreeContext);
  const userContext = useContext(CurrentUserContext);
  const user = userContext?.currentUser;
  const [expandedKeys, setExpandedKeys] = useState({});

  useEffect(() => {
    if (orgTreeDatabase && user && userDatabase && includeUsers) {
      const customUserTree = createNodesHighestAccessAndPersonalNode(
        user,
        orgTreeDatabase
      );

      setPersonalisedOrgTree(customUserTree);
    }
    if (orgTreeDatabase && user && !includeUsers) {
      const customUserTree = createAdminOrgTree(user, orgTreeDatabase);
      setPersonalisedOrgTree(customUserTree);
    }
  }, [orgTreeDatabase, user, userDatabase, includeUsers]);

  useEffect(() => {
    if (selectedTeam && personalisedOrgTree) {
      const defaultNode = findNodeById(
        personalisedOrgTree,
        selectedTeam.teamId
      );
      defaultNode && setSelectedNodeKey(defaultNode.key);
    }
  }, [selectedTeam, personalisedOrgTree]);

  const handleNodeSelect = (nodeKey: string) => {
    setSelectedNodeKey(nodeKey);
    if (orgTreeDatabase && personalisedOrgTree) {
      const selectedNode = findNodeByKey(personalisedOrgTree, nodeKey);
      if (selectedNode) {
        teamSelect(selectedNode);
      }
    }
  };

  type ToggleEvent = {
    value: { [key: string]: boolean };
  };

  const handleToggle = (e:ToggleEvent) => {
    setExpandedKeys(e.value);
  };

  return (
    <DashboardSelectWrapper>
      <TreeSelect
        value={selectedNodeKey}
        onChange={(e) => {
          typeof e.value == "string"
            ? handleNodeSelect(e.value)
            : console.log("no string value");
        }}
        options={personalisedOrgTree}
        filter
        placeholder={placeholder ? placeholder : "Select a Team"}
        expandedKeys={expandedKeys}
        onToggle={handleToggle}
      ></TreeSelect>
    </DashboardSelectWrapper>
  );
}

interface Props {
  includeUsers?: boolean;
  teamSelect: (e: OrgTreeItem) => void;
  selectedTeam?: OrgTreeItem | undefined;
  placeholder?: string;
}
